export const genders = [{
    value: "Male",
    label: "Male"
}, {
    value: "Female",
    label: "Female"
}, {
    value: "Non binary",
    label: "Non-Binary"
}, {
    value: "Other",
    label: "Other"
}]

